'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _helper = require('../../helpers/helper');

var _Item = require('./Item.scss');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Item, _Component);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Item).call(this, props));

    _this.state = {
      progress: 0,
      isModalOpen: props.needEdit
    };

    (0, _helper.bindAll)(_this);
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: '_renderContent',
    value: function _renderContent() {
      var _this2 = this;

      var _props = this.props;
      var info = _props.info;
      var mode = _props.mode;

      var imageUrl = '';
      if (mode === 'edit') {
        imageUrl = info.images[info.activeImg];
      } else {
        if (info.image) {
          var baseUrl = info.image.substring(0, 4) == 'http' ? '' : _config2.default.assetsUrl;
          imageUrl = baseUrl + info.image;
        }
      }
      return _react2.default.createElement(
        'div',
        { className: _Item2.default.container },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_Item2.default.image, (0, _defineProperty3.default)({}, _Item2.default.empty, imageUrl === '')), style: { backgroundImage: 'url(' + imageUrl + ')' } }),
        _react2.default.createElement(
          'div',
          { className: _Item2.default.details },
          _react2.default.createElement(
            'div',
            { className: _Item2.default.content },
            mode === 'edit' && _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  return _this2.props.onDelete(info.id);
                } },
              _react2.default.createElement('i', { className: 'ion-ios-close-empty' }),
              ' '
            ),
            _react2.default.createElement(
              'a',
              { className: (0, _classnames2.default)('hide-small', _Item2.default.url), href: 'http://' + info.store_url, target: '_blank' },
              info.store_url
            ),
            _react2.default.createElement(
              'p',
              { className: _Item2.default.title },
              ' ',
              info.title
            ),
            _react2.default.createElement(
              'div',
              { className: 'display-small' },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
                _react2.default.createElement(
                  'a',
                  { className: _Item2.default.url, href: 'http://' + info.store_url, target: '_blank' },
                  info.store_url
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Item2.default.price },
                  _react2.default.createElement(
                    'b',
                    null,
                    info.price ? info.price : 'Price not found'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('hide-small', _Item2.default.price) },
              'Est. price: ',
              _react2.default.createElement(
                'b',
                null,
                info.price
              )
            )
          ),
          _react2.default.createElement(
            'a',
            { onClick: this._openModal, className: _Item2.default.link },
            mode === 'edit' ? 'Edit item' : 'See more'
          )
        )
      );
    }
  }, {
    key: '_openModal',
    value: function _openModal() {
      this.setState({ isModalOpen: true });
    }
  }, {
    key: '_renderModalContent',
    value: function _renderModalContent() {
      var _this3 = this;

      var _props2 = this.props;
      var mode = _props2.mode;
      var info = _props2.info;
      var onEdit = _props2.onEdit;
      var _state = this.state;
      var progress = _state.progress;
      var isModalOpen = _state.isModalOpen;

      if (!isModalOpen) {
        return _react2.default.createElement('div', null);
      }
      if (mode === 'edit') {
        return _react2.default.createElement(_components.EditModal, { item: info, onClose: function onClose(item) {
            _this3.setState({ isModalOpen: false });
            onEdit(info.id, item);
          } });
      } else {
        return _react2.default.createElement(_components.SeeMoreModal, { item: info, onClose: function onClose() {
            return _this3.setState({ isModalOpen: false });
          } });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var mode = _props3.mode;
      var info = _props3.info;
      var isModalOpen = this.state.isModalOpen;

      return _react2.default.createElement(
        'div',
        null,
        this._renderContent(),
        this._renderModalContent()
      );
    }
  }]);
  return Item;
}(_react.Component), _class.propTypes = {
  info: _react.PropTypes.object,
  mode: _react.PropTypes.string
}, _class.defaultProps = {
  needEdit: false
}, _temp);
exports.default = Item;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/Item.js
 ** module id = 1098
 ** module chunks = 0
 **/